import { isFunction } from 'lodash/fp';

const validate = (validators) => (values, props, initialErrors = {}) => (isFunction(validators)
    ? validators(values, props)
    : validators
).reduce((errors, validator) => validator(errors, values, props), initialErrors);

export default validate;
